import Contact from './Contact'
import { Link, useLocation } from 'react-router-dom'
import Notification from 'features/myInfo/Notification'
import { useDialog } from '../dialog/Dialog'
import { ConfirmModal } from '../../components/dialog/ModalTemplate'
import AutoPayCard from './AutoPayCard'
import classNames from 'classnames'
import { useMemo } from 'react'

const { REACT_APP_BUSINESS_HOST } = process.env

const MyInfo = () => {
  const { search } = useLocation()
  const tab = useMemo(() => {
    const params = new URLSearchParams(search)
    return params.get('tab') || 'contact'
  }, [search])
  const [
    WithdrawalIntegrationDialog,
    showWithdrawalIntegrationDialog,
    hideWithdrawalIntegrationDialog,
  ] = useDialog()
  return (
    <>
      <h2 id="#kakaoBody" className="screen_out">
        내 정보 본문
      </h2>
      <div className="settingmyinfo_wrap">
        <div className="dsp_tit">
          <div className="tit_dsp">
            <h3 className="tit_subject">내 정보</h3>
            <div className="f_right">
              <div className="single_wrap">
                <button
                  type="button"
                  className="btn_gm gm_line"
                  onClick={showWithdrawalIntegrationDialog}>
                  <span className="inner_g">회원탈퇴</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <strong className="screen_out">내 정보 메뉴 탭</strong>
        <ul className="tab_g">
          <li className={classNames({ on: tab === 'contact' })}>
            <Link to="/myinfo" className="link_tab">
              계정정보 설정
            </Link>
          </li>
          <li className={classNames({ on: tab === 'autopaycard' })}>
            <Link to="?tab=autopaycard" className="link_tab">
              내 결제 카드
            </Link>
          </li>
          <li className={classNames({ on: tab === 'notification' })}>
            <Link to="?tab=notification" className="link_tab">
              알림 설정
            </Link>
          </li>
        </ul>
        {tab === 'contact' && <Contact />}
        {tab === 'autopaycard' && <AutoPayCard />}
        {tab === 'notification' && <Notification />}
      </div>
      <WithdrawalIntegrationDialog
        type="basic_layer"
        className="withdrawal_layer">
        <ConfirmModal
          title="회원탈퇴"
          showCancelBtn={false}
          handleClose={hideWithdrawalIntegrationDialog}>
          <div className="box_kakaobiz">
            <p className="desc_kakaobiz">
              회원탈퇴는 카카오 비즈니스에서 진행하실 수 있습니다.
            </p>
            <a
              href={`${REACT_APP_BUSINESS_HOST}/my-info/`}
              className="btn_gb gb_bl"
              target="_blank"
              rel="noopener noreferrer">
              <span className="inner_g">카카오 비즈니스로 이동</span>
            </a>
          </div>
        </ConfirmModal>
      </WithdrawalIntegrationDialog>
    </>
  )
}

export default MyInfo
